export default __webpack_public_path__ + "static/Thumbnail02-b8660b448515d388a9106fbf6b1daba9.png";